module.exports = __webpack_public_path__ + "static/img/84113B_5_R_20200318_fit.781428b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84113B_5_R_20200318_fit.png
// module id = iJwl
// module chunks = 0